<template>
    <div class="error-page">
        <div class="container">
            <div class="row">
                <div class="col-md-12">
                    <div class="eyes">
                        <div class="eye">
                            <div class="eye__pupil eye__pupil--left"></div>
                        </div>
                        <div class="eye">
                            <div class="eye__pupil eye__pupil--right"></div>
                        </div>
                    </div>
                </div>
                <div class="col-md-12">
                    <div class="error-page__heading text-center mt-5">
                        <h1 class="error-page__heading-title">Looks like you're lost</h1>
                    </div>
                    <div class="col-md-12 text-center mt-5">
                        <p class="error-page__heading-desciption">404 error</p>
                    </div>
                    <div class="col-md-12 text-center mt-5">
                        <a class="error-page__button" to="" aria-label="back to home" title="back to home">back to home</a>
                    </div>
                </div>
            </div>


        </div>

        <!--        <button class="color-switcher" @click="toggleTheme" aria-label="Switch Theme">-->
        <!--            {{ currentThemeIcon }}-->
        <!--        </button>-->
    </div>
</template>

<script>
    import {ref} from "vue";

    export default {
        name: "PageNotFound",
        setup() {
            const currentTheme = ref("light");
            const currentThemeIcon = ref("\u{1F319}"); // Moon emoji for dark theme

            const toggleTheme = () => {
                const root = document.documentElement;

                if (currentTheme.value === "dark") {
                    root.style.setProperty("--bg-color", "#fff");
                    root.style.setProperty("--text-color", "#000");
                    currentThemeIcon.value = "\u{1F319}"; // Moon icon
                    currentTheme.value = "light";
                } else {
                    root.style.setProperty("--bg-color", "#050505");
                    root.style.setProperty("--text-color", "#fff");
                    currentThemeIcon.value = "\u{2600}"; // Sun icon
                    currentTheme.value = "dark";
                }
            };

            return {
                currentTheme,
                currentThemeIcon,
                toggleTheme,
            };
        },
    };
</script>

<style>
    @import url("https://fonts.googleapis.com/css2?family=Fira+Sans:wght@200;500&display=swap");

    :root {
        --primary-color: #ffffff;
        --eye-pupil-color: #ff0000;
        --bg-color: #fff;
        --text-color: #000;
        --fs-heading: 36px;
        --fs-text: 26px;
        --fs-button: 18px;
        --fs-icon: 30px;
        --pupil-size: 30px;
        --eye-size: 80px;
        --button-padding: 15px 30px;
    }

    @media only screen and (max-width: 567px) {
        :root {
            --fs-heading: 30px;
            --fs-text: 22px;
            --fs-button: 16px;
            --fs-icon: 24px;
            --button-padding: 12px 24px;
        }
    }

    .error-page {
        margin: auto;
    }

    .error-page__heading-title {
        text-transform: capitalize;
        font-size: var(--fs-heading);
        font-weight: 500;
        color: var(--primary-color);
    }

    .error-page__heading-desciption {
        margin-top: 10px;
        font-size: var(--fs-text);
        font-weight: 200;
        color: #c90000;
    }

    .error-page__button {
        color: inherit;
        text-decoration: none;
        border: 1px solid var(--primary-color);
        font-size: var(--fs-button);
        font-weight: 200;
        padding: var(--button-padding);
        border-radius: 15px;
        box-shadow: 0px 7px 0px -2px var(--primary-color);
        transition: all 0.3s ease-in-out;
        text-transform: capitalize;
    }

    .error-page__button:hover {
        box-shadow: none;
        background-color: var(--primary-color);
        color: #fff;
    }

    .eyes {
        display: flex;
        justify-content: center;
        gap: 2px;
    }

    .eye {
        width: var(--eye-size);
        height: var(--eye-size);
        background-color: var(--primary-color);
        border-radius: 50%;
        display: grid;
        place-items: center;
    }

    .eye__pupil {
        width: var(--pupil-size);
        height: var(--pupil-size);
        background-color: var(--eye-pupil-color);
        border-radius: 50%;
        animation: movePupil 2s infinite ease-in-out;
        transform-origin: center center;
    }

    @keyframes movePupil {
        0%, 100% {
            transform: translate(0, 0);
        }
        25% {
            transform: translate(-10px, -10px);
        }
        50% {
            transform: translate(10px, 10px);
        }
        75% {
            transform: translate(-10px, 10px);
        }
    }

    .color-switcher {
        position: fixed;
        top: 40px;
        right: 40px;
        background-color: transparent;
        font-size: var(--fs-icon);
        cursor: pointer;
        color: var(--primary-color);
        border: 0;
    }
</style>
